import { faUndoAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createUseStyles } from 'react-jss';
import { FC } from 'react';
import { dictionary } from '../../dictionary';

const useSpinnerClasses = createUseStyles({
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(-1turn)' },
  },
  root: {
    '& svg': {
      animation: '$spin 0.8s linear infinite',
    },
  },
  large: {
    display: 'block',
    fontSize: '40px',
    margin: '64px auto',
  },
});

interface LoadingSpinnerProps {
  large?: boolean;
}

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ large = false }) => {
  const classes = useSpinnerClasses();

  return (
    <span className={`${classes.root} ${large ? classes.large : ''}`} data-testid="loading-spinner" data-size={large ? 'large' : 'default'}>
      <FontAwesomeIcon
        icon={faUndoAlt}
        title={dictionary.LOADING_SPINNER_TITLE}
        name={dictionary.LOADING_SPINNER_TITLE}
        role="status"
      />
    </span>
  );
};

LoadingSpinner.defaultProps = {
  large: false,
};
